var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form quick-deal-popup"
  }, [_c('div', {
    staticClass: "content-form-popup quick-deal-content"
  }, [_c('header', {
    staticClass: "quick-deal-header"
  }, [_c('button', {
    staticClass: "quick-deal-close",
    attrs: {
      "type": "button",
      "aria-label": "Zavrieť"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', [_c('span', {
    staticClass: "quick-deal-kicker"
  }, [_vm._v("Rýchly zápis obchodu")]), _c('h2', [_vm._v(_vm._s(_vm.clientName))]), !_vm.result ? _c('p', [_vm._v(" Evidencia už načerpanej hypotéky bez prepočtu a prechádzania celým procesom. ")]) : _vm._e()])]), _vm.result ? _c('div', {
    staticClass: "quick-deal-success"
  }, [_c('div', {
    staticClass: "quick-deal-success-icon"
  }, [_vm._v("✓")]), _c('h3', [_vm._v("Obchod bol zaevidovaný")]), _c('p', [_vm._v(" Hypotéka #" + _vm._s(_vm.result.mortgage.id) + " aj žiadosť sú v servise a klientovi bol vytvorený aktívny hypotekárny úver. ")]), _c('div', {
    staticClass: "quick-deal-success-summary"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedBankName))]), _c('strong', [_vm._v(_vm._s(_vm.formatMoney(_vm.form.suma)) + " EUR")]), _c('span', [_vm._v(_vm._s(_vm.form.sadzba) + " % · čerpanie " + _vm._s(_vm.formatDate(_vm.form.nacerpana)))])]), _c('div', {
    staticClass: "quick-deal-success-actions"
  }, [_c('button', {
    staticClass: "quick-deal-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("Hotovo")]), _c('button', {
    staticClass: "quick-deal-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openMortgage
    }
  }, [_vm._v(" Otvoriť hypotéku ")])])]) : _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "quick-deal-section-title"
  }, [_vm._v("Základné údaje zmluvy")]), _c('div', {
    staticClass: "quick-deal-grid"
  }, [_c('label', {
    staticClass: "quick-deal-field quick-deal-field--wide"
  }, [_c('span', [_vm._v("Banka *")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.bank,
      expression: "form.bank",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });
        _vm.$set(_vm.form, "bank", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Vyberte banku")]), _vm._l(_vm.banks, function (bank) {
    return _c('option', {
      key: bank.id,
      domProps: {
        "value": bank.id
      }
    }, [_vm._v(" " + _vm._s(bank.nazov) + " ")]);
  })], 2)]), _c('label', {
    staticClass: "quick-deal-field"
  }, [_c('span', [_vm._v("Účel *")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.ucel,
      expression: "form.ucel"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "ucel", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.purposes, function (purpose) {
    return _c('option', {
      key: purpose.value,
      domProps: {
        "value": purpose.value
      }
    }, [_vm._v(" " + _vm._s(purpose.label) + " ")]);
  }), 0)]), _c('label', {
    staticClass: "quick-deal-field"
  }, [_c('span', [_vm._v("Výška úveru *")]), _c('div', {
    staticClass: "quick-deal-input-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.suma,
      expression: "form.suma",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0.01",
      "step": "0.01",
      "required": ""
    },
    domProps: {
      "value": _vm.form.suma
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "suma", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('em', [_vm._v("EUR")])])]), _c('label', {
    staticClass: "quick-deal-field"
  }, [_c('span', [_vm._v("Schválená sadzba *")]), _c('div', {
    staticClass: "quick-deal-input-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.sadzba,
      expression: "form.sadzba",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "99.99",
      "step": "0.01",
      "required": ""
    },
    domProps: {
      "value": _vm.form.sadzba
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "sadzba", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('em', [_vm._v("%")])])]), _c('label', {
    staticClass: "quick-deal-field"
  }, [_c('span', [_vm._v("Mesačná splátka *")]), _c('div', {
    staticClass: "quick-deal-input-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.splatka,
      expression: "form.splatka",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0.01",
      "step": "0.01",
      "required": ""
    },
    domProps: {
      "value": _vm.form.splatka
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "splatka", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('em', [_vm._v("EUR")])])]), _c('label', {
    staticClass: "quick-deal-field"
  }, [_c('span', [_vm._v("Splatnosť *")]), _c('div', {
    staticClass: "quick-deal-input-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.splatnost,
      expression: "form.splatnost",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "40",
      "step": "1",
      "required": ""
    },
    domProps: {
      "value": _vm.form.splatnost
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "splatnost", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('em', [_vm._v("rokov")])])]), _c('label', {
    staticClass: "quick-deal-field"
  }, [_c('span', [_vm._v("Fixácia *")]), _c('div', {
    staticClass: "quick-deal-input-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.fix,
      expression: "form.fix",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "40",
      "step": "1",
      "required": ""
    },
    domProps: {
      "value": _vm.form.fix
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "fix", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('em', [_vm._v("rokov")])])])]), _c('div', {
    staticClass: "quick-deal-section-title"
  }, [_vm._v("Dokončenie a doplnkové údaje")]), _c('div', {
    staticClass: "quick-deal-grid"
  }, [_c('label', {
    staticClass: "quick-deal-field quick-deal-field--important"
  }, [_c('span', [_vm._v("Dátum načerpania *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.nacerpana,
      expression: "form.nacerpana"
    }],
    attrs: {
      "type": "date",
      "max": _vm.today,
      "required": ""
    },
    domProps: {
      "value": _vm.form.nacerpana
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "nacerpana", $event.target.value);
      }
    }
  })]), _c('label', {
    staticClass: "quick-deal-field"
  }, [_c('span', [_vm._v("Deň splátky *")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.preferred_payment_day,
      expression: "form.preferred_payment_day",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });
        _vm.$set(_vm.form, "preferred_payment_day", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Vyberte deň")]), _vm._l(_vm.paymentDays, function (day) {
    return _c('option', {
      key: day,
      domProps: {
        "value": day
      }
    }, [_vm._v(_vm._s(day) + ". deň")]);
  })], 2)]), _c('label', {
    staticClass: "quick-deal-field"
  }, [_c('span', [_vm._v("Číslo úveru / zmluvy")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.cislo_uveru,
      expression: "form.cislo_uveru",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "maxlength": "64",
      "placeholder": "Voliteľné"
    },
    domProps: {
      "value": _vm.form.cislo_uveru
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "cislo_uveru", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('label', {
    staticClass: "quick-deal-field"
  }, [_c('span', [_vm._v("Poplatok za poskytnutie")]), _c('div', {
    staticClass: "quick-deal-input-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.poplatok_za_poskytnutie,
      expression: "form.poplatok_za_poskytnutie",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "placeholder": "0"
    },
    domProps: {
      "value": _vm.form.poplatok_za_poskytnutie
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "poplatok_za_poskytnutie", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('em', [_vm._v("EUR")])])]), _c('label', {
    staticClass: "quick-deal-field quick-deal-field--wide"
  }, [_c('span', [_vm._v("Interná poznámka")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.poznamka,
      expression: "form.poznamka",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "rows": "3",
      "placeholder": "Napr. obchod evidovaný spätne, kontakt v banke..."
    },
    domProps: {
      "value": _vm.form.poznamka
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "poznamka", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _c('div', {
    staticClass: "quick-deal-section-title"
  }, [_vm._v("Dokumentácia obchodu")]), _c('div', {
    staticClass: "quick-deal-record-upload"
  }, [_vm._m(1), !_vm.signedClientNeedsRecord ? _c('label', {
    staticClass: "quick-deal-file-button"
  }, [_c('input', {
    ref: "signedClientNeedsRecordInput",
    attrs: {
      "type": "file",
      "accept": ".pdf,.png,.jpg,.jpeg,.doc,.docx,.asice"
    },
    on: {
      "change": _vm.selectSignedClientNeedsRecord
    }
  }), _vm._v(" Nahrať dokument ")]) : _c('div', {
    staticClass: "quick-deal-selected-file"
  }, [_c('span', [_vm._v(_vm._s(_vm.signedClientNeedsRecord.name))]), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeSignedClientNeedsRecord
    }
  }, [_vm._v("Odobrať")])])]), _vm.recordError ? _c('p', {
    staticClass: "quick-deal-record-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.recordError))]) : _vm._e(), _vm.errors.length ? _c('div', {
    staticClass: "quick-deal-errors",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Skontrolujte zadané údaje:")]), _vm._l(_vm.errors, function (error, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(error))]);
  })], 2) : _vm._e(), _c('footer', {
    staticClass: "quick-deal-footer"
  }, [_c('button', {
    staticClass: "quick-deal-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v(" Zrušiť ")]), _c('button', {
    staticClass: "quick-deal-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving || !_vm.canSubmit
    }
  }, [_vm.saving ? _c('span', [_vm._v("Evidujem obchod...")]) : _c('span', [_vm._v("Zaevidovať načerpaný obchod")])])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "quick-deal-info"
  }, [_c('span', {
    staticClass: "quick-deal-info-icon"
  }, [_vm._v("i")]), _c('p', [_vm._v(" Uložením sa vytvorí hypotéka v "), _c('strong', [_vm._v("servise")]), _vm._v(", žiadosť v stave "), _c('strong', [_vm._v("načerpaná")]), _vm._v(" a aktívny dlh klienta. Dátum čerpania sa použije aj pre evidenciu dokončeného obchodu. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('strong', [_vm._v("Záznam o sprostredkovaní / potrebách klienta")]), _c('p', [_vm._v("Voliteľne priložte podpísaný dokument. Uloží sa priamo k vytvorenej žiadosti a zobrazí sa aj v checkliste čerpania.")])]);

}]

export { render, staticRenderFns }